import CircularProgress from '@mui/material/CircularProgress';
import Button, { ButtonProps } from 'atoms/Button';
import cn from 'classnames';
import React from 'react';

import s from '../common/Button.module.scss';

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
  component?: string;
}

const CustomButton = ({ loading, component, ...rest }: LoadingButtonProps) => {
  return (
    <Button
      disableRipple
      disableElevation
      {...rest}
      disabled={rest.disabled || loading}
      className={cn(s['MaterialButton-root'], rest.className, { isLoading: loading })}
    >
      {loading && (
        <CircularProgress className={s['MaterialButton-root__loader']} color="inherit" size={20} />
      )}
      <span
        className={cn(s['MaterialButton-root__text'], {
          [s['MaterialButton-root__text--loading']]: loading
        })}
      >
        {rest.children}
      </span>
    </Button>
  );
};

export default CustomButton;
